import { $, BREAKPOINTS } from '../_utils'

// TODO: more things to come to make this page interactive. Need APIs...

window.addEventListener('DOMContentLoaded', () => {
  const isMobile = document.body.clientWidth < BREAKPOINTS.lg
  const $searchResultsContainer = $('.sales-reps__search')
  const $contactInfo = $('#results-agent-box')
  if ($searchResultsContainer && isMobile) {
    if ($contactInfo) $contactInfo.classList.remove('sales-reps__agent-box--wide')
  } else if ($searchResultsContainer) {
    $contactInfo.classList.add('sales-reps__agent-box--wide')
  }
})
